module.exports = __webpack_public_path__ + "img/map_1791533251399_41000.3cbc0bc2.jpg";